<template>
<div class="my-demand">
    <template v-if="tempNum==1">
        <!-- 使用 tabs 切换需求和建议 -->
        <el-tabs v-model="searchData.dem_type" @tab-click="onTypeChange" class="demand-tabs">
            <el-tab-pane label="需求" name="1">
                <div class="search-box">
                    <el-form :inline="true" :model="searchData" size="mini">
                        <el-form-item label="日期">
                            <el-date-picker
                                v-model="searchData.date"
                                type="daterange"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                :unlink-panels="true"
                                >
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="OE号">
                            <el-input v-model="searchData.oecode" class="oe-el-input"></el-input>
                        </el-form-item>
                        <el-form-item label="状态">
                            <el-select v-model="searchData.state" class="small-select">
                                <el-option label="未回复" value="0"></el-option>
                                <el-option label="已回复" value="1"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="客户名称" v-if="isHnw">
                            <el-input v-model="searchData.store_name" class="oe-el-input"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="onSubmit">搜索</el-button>
                            <el-button @click="clearSearch">清空</el-button>
                            <el-button type="primary" v-if="!isHnw" @click="pubNewDemand">发布新需求</el-button>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="damand-table">
                    <div class="table-head">
                        <div class="index">序号</div>
                        <!-- <div class="check"></div> -->
                        <div class="oecode">OE号</div>
                        <div class="sccode">产品名称</div>
                        <div class="brand">适用车型</div>
                        <div class="num">需求数量</div>
                        <div class="num">客户名称</div>
                        <div class="desc">改进建议</div>
                        <div class="pubTime">发布时间</div>
                        <div class="pubState">状态</div>
                        <div class="handle">操作</div>
                    </div>
                    <div class="table-body">
                        <div class="table-row" v-for="(item,index) in demandList" :key="index">
                            <div class="index">{{index + 1}}</div>
                            <!-- <div class="check">
                                <el-checkbox v-model="item.choose"></el-checkbox>
                            </div> -->
                            <div class="oecode">{{item.oecode}}</div>
                            <div class="sccode">{{item.goods_name}}</div>
                            <div class="brand">{{item.vehicletype}}</div>
                            <div class="num">{{item.dem_num}}</div>
                            <div class="num">{{item.store_name}}</div>
                            <div class="desc">{{item.parts_cri}}</div>
                            <div class="pubTime" :title="item.add_time">{{item.add_time}}</div>
                            <div class="pubState" :class="{unreplied: item.state=='0'}">{{item.state=='0'?'未回复':'已回复'}}</div>
                            <div class="handle">
                                <!-- 管理账号显示回复和查看详情 -->
                                <template v-if="isHnw">
                                    <div v-if="item.state=='0'" @click="readInfo(item)">回复</div>
                                    <div v-else @click="readInfo(item)">查看详情</div>
                                </template>
                                
                                <!-- 非管理账号显示编辑、查看详情和删除 -->
                                <template v-else>
                                    <div v-if="item.state=='0'" @click="edit(item)">编辑</div>
                                    <div @click="readInfo(item)">查看详情</div>
                                    <div v-if="item.state=='0'" class="shu"></div>
                                    <div v-if="item.state=='0'" @click="del(item.dem_id)">删除</div>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="pagination-box" v-if="total > 0">
                    <el-pagination
                        background
                        @current-change="handleCurrentChange"
                        :current-page="currentPage"
                        :page-size="pageSize"
                        layout="total, prev, pager, next, jumper"
                        :total="total">
                    </el-pagination>
                </div>
                <div class="betcHandle" v-if="!isHnw">
                    <!-- <el-checkbox v-model="allChoose" @change="allChange">全选</el-checkbox> -->
                    <!-- <div class="betchDel"  @click="del('betch')">删除</div> -->
                </div>
            </el-tab-pane>
            
            <el-tab-pane label="建议" name="2">
                <div class="search-box">
                    <el-form :inline="true" :model="searchData" size="mini">
                        <el-form-item label="日期">
                            <el-date-picker
                                v-model="searchData.date"
                                type="daterange"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                :unlink-panels="true"
                                >
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="状态">
                            <el-select v-model="searchData.state" class="small-select">
                                <el-option label="未回复" value="0"></el-option>
                                <el-option label="已回复" value="1"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="onSubmit">搜索</el-button>
                            <el-button @click="clearSearch">清空</el-button>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="damand-table">
                    <div class="table-head">
                        <div class="index">序号</div>
                        <div class="desc">改进建议</div>
                        <div class="pubTime">发布时间</div>
                        <div class="reply">官方回复</div>
                        <div class="pubState">状态</div>
                        <div class="handle">操作</div>
                    </div>
                    <div class="table-body">
                        <div class="table-row" v-for="(item,index) in demandList" :key="index">
                            <div class="index">{{index + 1}}</div>
                            <div class="desc" :title="item.parts_cri">{{item.parts_cri}}</div>
                            <div class="pubTime" :title="item.add_time">{{item.add_time}}</div>
                            <div class="reply" :title="item.rem_bz">{{item.rem_bz || '暂无回复'}}</div>
                            <div class="pubState" :class="{unreplied: item.state=='0'}">{{item.state=='0'?'未回复':'已回复'}}</div>
                            <div class="handle">
                                <!-- 管理账号显示回复和查看详情 -->
                                <template v-if="isHnw">
                                    <div v-if="item.state=='0'" @click="readInfo(item)">回复</div>
                                    <div v-else @click="readInfo(item)">查看详情</div>
                                </template>
                                
                                <!-- 非管理账号只显示查看详情 -->
                                <template v-else>
                                    <div @click="readInfo(item)">查看详情</div>
                                    <div v-if="item.state=='0'" @click="del(item.dem_id)">删除</div>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="pagination-box" v-if="total > 0">
                    <el-pagination
                        background
                        @current-change="handleCurrentChange"
                        :current-page="currentPage"
                        :page-size="pageSize"
                        layout="total, prev, pager, next, jumper"
                        :total="total">
                    </el-pagination>
                </div>
            </el-tab-pane>
            <el-tab-pane label="投诉" name="3">
                <div class="search-box">
                    <el-form :inline="true" :model="searchData" size="mini">
                        <el-form-item label="日期">
                            <el-date-picker
                                v-model="searchData.date"
                                type="daterange"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                :unlink-panels="true"
                                >
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="状态">
                            <el-select v-model="searchData.state" class="small-select">
                                <el-option label="未回复" value="0"></el-option>
                                <el-option label="已回复" value="1"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="严重类型">
                            <el-select v-model="searchData.dem_num" class="small-select">
                                <el-option label="一般" value="1"></el-option>
                                <el-option label="严重" value="2"></el-option>
                                <el-option label="很严重" value="3"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="onSubmit">搜索</el-button>
                            <el-button @click="clearSearch">清空</el-button>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="damand-table">
                    <div class="table-head">
                        <div class="index">序号</div>
                        <div class="desc">投诉内容</div>
                        <div class="pubTime">发布时间</div>
                        <div class="reply">官方回复</div>
                        <div class="pubState">状态</div>
                        <div class="pubState">严重类型</div>
                        <div class="handle">操作</div>
                    </div>
                    <div class="table-body">
                        <div class="table-row" v-for="(item,index) in demandList" :key="index">
                            <div class="index">{{index + 1}}</div>
                            <div class="desc" :title="item.parts_cri">{{item.parts_cri}}</div>
                            <div class="pubTime" :title="item.add_time">{{item.add_time}}</div>
                            <div class="reply" :title="item.rem_bz">{{item.rem_bz || '暂无回复'}}</div>
                            <div class="pubState" :class="{unreplied: item.state=='0'}">{{item.state=='0'?'未回复':'已回复'}}</div>
                            <div class="pubState" >{{ getSeverityText(item.dem_num) }}</div>
                            <div class="handle">
                                <!-- 管理账号显示回复和查看详情 -->
                                <template v-if="isHnw">
                                    <div v-if="item.state=='0'" @click="readInfo(item)">回复</div>
                                    <div v-else @click="readInfo(item)">查看详情</div>
                                </template>
                                
                                <!-- 非管理账号只显示查看详情 -->
                                <template v-else>
                                    <div @click="readInfo(item)">查看详情</div>
                                    <div v-if="item.state=='0'" @click="del(item.dem_id)">删除</div>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="pagination-box" v-if="total > 0">
                    <el-pagination
                        background
                        @current-change="handleCurrentChange"
                        :current-page="currentPage"
                        :page-size="pageSize"
                        layout="total, prev, pager, next, jumper"
                        :total="total">
                    </el-pagination>
                </div>
            </el-tab-pane>
        </el-tabs>
    </template>
    <template v-if="tempNum==2">
        <div class="demandInfo">
            <div class="container-box">
                <div class="title">
                    {{searchData.dem_type === '1' ? '需求详情' : '建议详情'}}
                </div>
                <div class="body">
                    <!-- 需求详情显示所有字段 -->
                    <template v-if="searchData.dem_type == '1'">
                        <div class="item">
                            <div class="label">
                                OE号
                            </div>
                            <div class="value">
                                {{demandData.oecode}}
                            </div>
                        </div>

                        <div class="item">
                            <div class="label">
                                产品名称
                            </div>
                            <div class="value">
                                {{demandData.goods_name}}
                            </div>
                        </div>

                        <div class="item">
                            <div class="label">
                                适用车型
                            </div>
                            <div class="value">
                                {{demandData.vehicletype}}
                            </div>
                        </div>
                        <div class="item">
                            <div class="label">
                                需求数量
                            </div>
                            <div class="value">
                                {{demandData.dem_num}}
                            </div>
                        </div>
                    </template>
                    <template v-if="searchData.dem_type == '3'">
                        <div class="item">
                            <div class="label">
                                严重类型
                            </div>
                            <div class="value">
                                {{ getSeverityText(demandData.dem_num) }}
                            </div>
                        </div>
                    </template>
                    <!-- 建议和需求都显示的通用字段 -->
                    <div class="item">
                        <div class="label">
                            发布时间
                        </div>
                        <div class="value">
                            {{demandData.add_time}}
                        </div>
                    </div>
                    <div class="item">
                        <div class="label">
                            发布人
                        </div>
                        <div class="value">
                             {{demandData.member_name}}
                        </div>
                    </div>
                    <div class="item">
                        <div class="label">
                            发布公司
                        </div>
                        <div class="value">
                             {{demandData.store_name}}
                        </div>
                    </div>
                    
                    <div class="item">
                        <div class="label">
                            改进建议
                        </div>
                        <div class="value">
                            {{demandData.parts_cri}}
                        </div>
                    </div>
                    
                    <!-- 图片预览 -->
                    <div class="item" v-if="demandData.img_name ">
                        <div class="label">
                            图片
                        </div>
                        <div class="value">
                            <el-image
                                v-for="(imgUrl, index) in getImageUrls()"
                                :key="index"
                                :src="imgUrl"
                                :preview-src-list="getImageUrls()"
                                :initial-index="index"
                                style="width: 100px; height: 100px; margin-right: 10px;"
                                fit="cover"
                                lazy
                            ></el-image>
                        </div>
                    </div>
                    
                    <!-- 文件下载 -->
                    <div class="item" v-if="demandData.fullname ">
                        <div class="label">
                            附件
                        </div>
                        <div class="value">
                            <a 
                                v-for="(fileUrl, index) in getFileUrls()" 
                                :key="index"
                                :href="fileUrl" 
                                :download="getFileNameFromUrl(fileUrl)"
                                target="_blank"
                                style="display: block; margin-bottom: 5px;"
                            >
                                下载文件 {{ index + 1 }}
                            </a>
                        </div>
                    </div>
                    
                    <div class="item">
                        <div class="label">
                            状态
                        </div>
                        <div class="value">
                            {{demandData.state=='0'?'未回复':'已回复'}}
                        </div>
                    </div>

                </div>

            </div>
            <div class="container-box">
                <div class="title">
                    官方回复
                </div>
                <div class="body">
                    <div class="item" v-if="demandData.state!=0">
                        <div class="label">
                            回复
                        </div>
                        <div class="bz">
                            <div class="row">
                                <div>
                                     {{demandData.rem_bz}}
                                </div>
                                <div>
                                    {{demandData.rem_bzTime}}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="item" v-else>
                         <div class="label">
                            回复
                        </div>
                        <div class="value">
                            <el-input v-if="isHnw" type="textarea" v-model="verifyData.rem_bz"></el-input>
                            <div v-else>
                                {{demandData.rem_bz}}
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <div class="btn-box">
                  <el-button @click="tempNum=1">返回</el-button>
                  <el-button type="primary"  v-if="isHnw&&demandData.state==0" @click="revert">提交</el-button>
            </div>
        </div>
    </template>
    <template v-if="tempNum==3">
        
         
        <div class="form-box">
            <!--  -->
          <el-form :model="pubDemand" status-icon  ref="demandFrom" label-width="100px" :rules="demandRules">
                <el-form-item label="OE号" prop="oecode">
                    <el-input type="text" v-model="pubDemand.oecode"></el-input>
                </el-form-item>
                <el-form-item label="产品名称" prop="goods_name">
                    <el-input type="text" v-model="pubDemand.goods_name"></el-input>
                </el-form-item>
                
                <el-form-item label="适配车型" prop="vehicletype">
                    <el-input type="text" v-model="pubDemand.vehicletype"></el-input>
                </el-form-item>
                
                <el-form-item label="需求数量" prop="dem_num">
                    <el-input type="text" v-model="pubDemand.dem_num"></el-input>
                </el-form-item>
                
                <el-form-item label="改进建议" prop="parts_cri">
                    <el-input type="text" v-model="pubDemand.parts_cri"></el-input>
                </el-form-item>
            
                <el-form-item>
                    <el-button @click="resetForm">放弃</el-button>
                    <el-button type="primary" @click="submitForm">发布</el-button>
                </el-form-item>
            </el-form>
        </div>
    </template>
</div>
</template>

<script>
export default {
    data(){
        return{
            searchData:{
                date:[],
                oe_code:"",
                state:"",
                start_time:"",
                end_time:"",
                store_name:"",
                dem_type:"1" // 默认查询需求类型
            },
            isEdit:false,
            upImgData:{
                store_id:this.$store.state.store_id
            },
            isHnw:this.$store.state.store_id==1780,
            rebackFlag:false,
            radio:"1",
            verifyData:{
                is_goods:"",
                offer_price:"",
                type:"1",
                rem_bz:""
            },
            rem_text:"",
            demandList:[
               
            ],
            imgList:[],
            allChoose:false,
            tempNum:1,
            demandData:"",
            dem_id:"",
            // 分页相关数据
            currentPage: 1,
            pageSize: 10,
            total: 0,
            // 发布需求的字段
            pubDemand:{
                parts_cri:"",
                dem_num:"",
                oecode:"",
                goods_name:"",
                vehicletype:"",
                member_name:"",
                dem_id:""
            },
            demandRules:{
                // 根据项目规范，需求表单中的所有字段均为非必填项
            }
        }
    },
    methods:{
        // 获取图片URL数组
        getImageUrls() {
            if (this.demandData.img_name) {
                return this.demandData.img_name.split(',').filter(url => url.trim() !== '');
            }
            return [];
        },
        
        // 获取文件URL数组
        getFileUrls() {
            if (this.demandData.fullname) {
                return this.demandData.fullname.split(',').filter(url => url.trim() !== '');
            }
            return [];
        },
        
        // 从URL中提取文件名
        getFileNameFromUrl(url) {
            if (!url) return '';
            const urlParts = url.split('/');
            return urlParts[urlParts.length - 1];
        },
        
        // 类型切换事件
        onTypeChange() {
            // 重置到第一页并重新获取列表
            this.currentPage = 1;
            this.getList();
        },
        async onSubmit(){
            const {date} = this.searchData
            if(date.length==2){
                console.log(date)
                this.searchData.start_time = new Date(date[0]).getTime()/1000
                this.searchData.end_time = new Date(date[1]).getTime()/1000
            }
            // 搜索时重置到第一页
            this.currentPage = 1
            this.getList()
            this.rebackFlag  = true
        },
        pubNewDemand(){
            this.tempNum = 3
            this.isEdit = false

        },
        // 获取严重类型文本
		getSeverityText(severity) {
            switch(severity){
                case '1': return '一般';
                case '2': return '严重';
                case '3': return '很严重';
                default: return '';
            }
        },
        reBack(){
            this.rebackFlag  = false
            this.searchData = {
                date: [],
                oe_code: "",
                state: "",
                start_time: "",
                end_time: "",
                store_name: "",
                dem_type: "" // 重置类型筛选
            }
            // 重置分页
            this.currentPage = 1
            this.getList()
        },
        upImgOver(res){
            console.log("图片上传成功",res)
          

            this.pubDemand.img_name += res.data.file_name+","
        },
        removeImg(file){
            // file.name
            this.pubDemand.img_name = this.pubDemand.img_name.replace(file.name+',',"")
        },
        async submitForm(){
          
            this.$refs.demandFrom.validate(async (flag,obj)=>{
                console.log("未通过字段是:",obj)
                if(flag){
                    let res = ''
                    if(this.isEdit){
                        res = await this.$api.editDemand({
                            store_id:this.$store.state.store_id,
                            member_id:this.$store.state.member_id,
                            member_name:this.$store.state.member_name,
                            // nickname:this.$store.state.nickname,
                            ...this.pubDemand
                        })
                    }else{
                        this.pubDemand.dem_id = ""
                        res = await this.$api.pubDemand({
                            store_id:this.$store.state.store_id,
                            member_id:this.$store.state.member_id,
                            member_name:this.$store.state.member_name,
                            // nickname:this.$store.state.nickname,
                            ...this.pubDemand
                        })
                    }
                    
                    if(res){
                        this.$suMsg("发布成功")
                        this.resetForm()
                        // \\ // \\ // \\ // \\ // \\ || \\ console.log('')
                        for(let key in this.searchData){
                            this.searchData[key] = ""
                        }
                        this.getList()
                        this.resetForm()
                    }else{
                        
                        this.$erMsg("发布失败")
                    }
                }

            })
        },
        resetForm(){
            for(let key in this.pubDemand){
                this.pubDemand[key] = ""
            }
            this.imgList = []
            this.tempNum = 1
        },
        async getList(){
            // 构造请求参数
            let params = {
                store_id:this.$store.state.store_id,
                member_id:this.$store.state.member_id,
                page: this.pageSize,
                curpage: this.currentPage,
                ...this.searchData
            };
            
            // 如果是管理账号，添加all参数
            if (this.isHnw) {
                params.all = 'all';
            }
            let res = await this.$api.getDemandList(params);
            if(this.$store.state.store_id!="1780"||this.$store.state.storePath.includes('deDemandAudit')){
                // 更新分页数据
                this.demandList = res.data;
                this.total = Number(res.total); // 假设API返回总数量字段为count
                
                this.demandList.forEach(item=>{
                    this.$set(item,"choose",false)
                    // 更新已读 
                    if (this.$store.state.store_id=="1780"&&!item.remarks) {
                        // 可以在这里添加特定的处理逻辑
                        console.log('从需求审核通知跳转过来');
                        this.$api.updateMessage({
                            type:"demand", // demand表示需求，poster表示海报
                            remarks:"1",
                            id:item.dem_id // 消息id
                        })
                    }
                    if(this.$store.state.store_id!="1780"&&item.state=="1"){
                        this.$api.updateMessage({
                            type:"demand", // demand表示需求，poster表示海报
                            remarks:"2",
                            id:item.dem_id // 消息id
                        })
                    }
                   
                })
            }
        },
        
        // 分页处理方法
        handleCurrentChange(val) {
            this.currentPage = val;
            this.getList();
        },
        
        // 清空搜索条件
        clearSearch() {
            const currentType = this.searchData.dem_type; // 保存当前的 dem_type
            this.searchData = {
                date: [],
                oe_code: "",
                state: "",
                start_time: "",
                end_time: "",
                store_name: "",
                dem_type: currentType // 保持当前的类型
            };
            this.currentPage = 1;
            this.getList();
            this.rebackFlag = false;
        },
        
        del(dem_id){
            
            let demId = ""
            let tit = "确定要删除这个需求?"
            let ids = []
            if(dem_id=='betch'){
                this.demandList.forEach(item=>{
                    if(item.choose){
                        demId +=item.dem_id + ","
                        ids.push(item.dem_id)
                    }
                })   
                tit= "确定要删除这些需求？"
            }else{
                demId = dem_id + ""
                ids.push(dem_id)
            }
            this.$confirm(tit, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                })
                .then(async () => {
                    this.$message({
                        type: 'success',
                        message: '删除成功!'
                    });
                    await this.$api.delDemand({
                        dem_id:demId
                    })
                    // await this.$http("index.php?act=store_demand&op=demand_del",{
                    //     dem_id:demId
                    // })
                   
                    let temp =  this.demandList.filter(item=>ids.indexOf(item.dem_id)==-1)
                    this.$set(this,"demandList",temp)
                })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });          
             });
        },
        // 查看详情
        async readInfo(demItem){
            this.tempNum = 2
            this.dem_id =  demItem.dem_id
            // this.demandData =  await this.$api.getDemandInfo({
            //     dem_id
            // })
            this.demandData = {...demItem} 
            this.verifyData.is_goods = this.demandData.is_goods
            this.verifyData.offer_price = this.demandData.offer_price
            
            if(this.demandData.state!="0"){
                let {rem_bz} = this.demandData
                console.log("1正在")
                if(rem_bz){
                    
                     let arr = rem_bz.split(",")
                     let remTime = arr[arr.length-1]
                     arr.pop()
                     this.demandData.rem_bz = arr.join("")
                     this.demandData.rem_bz = this.demandData.rem_bz||"暂无回复"
                     this.demandData.rem_bzTime = remTime
                     this.verifyData.type = 2
                }
                // if(rem_bz1){
                //      let arr = rem_bz1.split(",")
                     
                //      let remTime = arr[arr.length-1]
                //      arr.pop()
                //      this.demandData.rem_bz1 = arr.join("")
                //      this.demandData.rem_bz1 = this.demandData.rem_bz1||"暂无回复"
                //      this.verifyData.type = 3
                //      this.demandData.rem_bz1Time = remTime
                // }
                // if(rem_bz2){
                //      let arr = rem_bz2.split(",")
                //      let remTime = arr[arr.length-1]
                //      arr.pop()
                //      this.demandData.rem_bz2 = arr.join("")
                //       this.demandData.rem_bz2 = this.demandData.rem_bz2||"暂无回复"
                //      this.demandData.rem_bz2Time = remTime
                // }
            }
           
        },
        edit(demand){
            this.tempNum = 3
            this.isEdit = true
            console.log(demand)

            this.pubDemand  = JSON.parse(JSON.stringify(demand))
        },
        // 回复
        async revert(){
            
            const res = await this.$api.verifyDemadn({
                dem_id:this.dem_id,
                ...this.verifyData
            })
            
            
            this.$suMsg("回复成功")
            for(let k in this.verifyData){
                this.verifyData[k] = ""
            }
            this.getList()
            this.tempNum = 1
        },
        allChange(flag){
            this.demandList.forEach(item=>{
                this.$set(item,"choose",flag)
            })
        }
    },
    created(){
        // 默认查询需求类型
        this.searchData.dem_type = "1";
        this.getList();
        
        // 判断是否是点击需求审核通知过来的
        if (this.$route.query.from === 'demandAudit') {
            // 可以在这里添加特定的处理逻辑
            console.log('从需求审核通知跳转过来');
        }
    },
    watch:{
        "$store.state.pageNavHis":{
            deep:true,
            handler(pageNavHis){
                this.demandData = pageNavHis.demandData
                this.verifyData = pageNavHis.verifyData
                this.tempNum = pageNavHis.tempNum
            }
        }
    }
}

</script>

<style lang="scss">
.my-demand{
    background: #fff;
    padding: $leftPad;
    .search-box{
        .el-input__inner{
            border-radius: 0;
        }
    }
    .de-title{
        padding: 10px;
        background: #efefef;
        i{
            color: cornflowerblue;
            font-size: 16px;
        }
    }
    .reBtn{
        padding: 10px;
    }
    .damand-table{
        border: 1px solid #ccc;
        border-left: 0;
        border-right: 0;
        .table-head{
            background: #F7F7F7;
            margin-bottom: 10px;
            height: 38px;
            line-height: 38px;
            text-align: center;
            display: flex;
            .check{
                min-width: 40px;
                max-width: 40px;
            }
            .index{
                min-width: 40px;
                max-width: 40px;
            }
            >div{
                flex: 1;
                padding: 0 3px;
            }
            .desc {
                flex: 2; // 改进建议列更宽一些
                max-width: 212px;
                min-width: 212px;
                text-align: left;
            }
            .pubTime {
                flex: 1; // 发布时间列
                min-width: 80px;
                max-width: 80px;
            }
            .pubState {
                min-width: 60px;
                max-width: 60px;
                
            }
            .reply {
                flex: 1; // 官方回复列
                min-width: 480px;
                max-width: 480px;
            }
            .handle{
                min-width: 150px;
                max-width: 150px;
            }
        }
        .table-body{
            .table-row{
                display: flex;
                border-top: 1px solid #ccc;
                >div{
                    padding: 8px 3px;
                    // padding: 8px 5px;
                    text-align: center;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    flex: 1;
                }
                .check{
                    min-width: 40px;
                    max-width: 40px;
                }
                .index{
                    min-width: 40px;
                    max-width: 40px;
                }
                .desc {
                    flex: 1; // 改进建议列更宽一些
                    max-width: 212px;
                    min-width: 212px;
                    text-align: left;
                }
                .pubTime {
                    flex: 1; // 发布时间列
                    min-width: 80px;
                    max-width: 80px;
                }
                .pubState {
                    min-width: 60px;
                    max-width: 60px;
                    &.unreplied {
                        color: red;
                    }
                }
                .reply {
                    flex: 1; // 官方回复列
                    min-width: 480px;
                    max-width: 480px;
                }
                .handle{
                    display: flex;
                    min-width: 150px;
                     max-width: 150px;
                    justify-content: center;
                    
                    >div{
                        cursor: pointer;
                        color: #3A82D4;
                        margin:  0 5px;
                    }
                    .shu{
                       
                        cursor: default;
                        height: 80%;
                        width: 1px;
                        transform: translateY(1px);
                        background: #CCCCCC;
                    }
                }
            }
        }
    }
    .pagination-box {
        margin: 20px 0;
        display: flex;
        justify-content: flex-end;
    }
    .betcHandle{
        padding: 10px 5px;
        display: flex;
        align-items: center;
        color: #3A82D4;
        label{
            margin-left: 8px;
        }
        .betchDel{
            margin: 0 8px;
            cursor: pointer;
        }
    }
    // 需求详情
    .demandInfo{
        .container-box{
            margin-top: 60px;
            .title{
                font-size: 18px;
                color:rgba(58,130,212,1);
                height: 40px;
                text-align: center;
                line-height:40px;
                background: #FCF9FC;
                border: 1px solid #ccc;
            }
            .body{
                .item{
                    border: 1px solid #ccc;
                    border-top: none;
                    display: grid;
                    grid-template-columns:150px 1fr;
                    >div{
                        padding: 8px 0;
                    }  
                    .label{
                        font-size: 15px;
                        text-align: center;
                        border-right: 1px solid #ccc;
                    }
                    .value{
                        padding-left: 40px;
                        padding-right: 40px;
                        white-space: normal;
                        word-wrap: break-word;
                        word-break: break-word;
                    }
                    .bz{
                         padding-left: 40px;
                         line-height: 20px;
                         >div{
                            
                         }
                         .row{
                             display: flex;
                             div:first-child{
                                  width: 600px;
                                  white-space: normal;
                                  overflow: visible;
                                  text-overflow: clip;
                                  margin-right: 20px;
                             }
                         }
                    }
                }
            }
        }
        .btn-box{
            padding: 20px;
            text-align: center;
        }
    }
   
}
</style>